/* GENERATED by scripts/gen-data.mjs — film scene "f-softmax" (from s1.js + s2.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { FilmScene } from '../../types';

export const F_SOFTMAX: FilmScene = {
  "w": 640,
  "h": 300,
  "items": [
    {
      "k": "note",
      "id": "h1",
      "x": 60,
      "y": 30,
      "lKey": "films:f-softmax.items.h1.l"
    },
    {
      "k": "note",
      "id": "h2",
      "x": 450,
      "y": 30,
      "lKey": "films:f-softmax.items.h2.l"
    },
    {
      "k": "bar",
      "id": "l1",
      "x": 60,
      "y": 64,
      "w": 170,
      "h": 14,
      "v": 0.95,
      "lKey": "films:f-softmax.items.l1.l"
    },
    {
      "k": "bar",
      "id": "l2",
      "x": 60,
      "y": 112,
      "w": 170,
      "h": 14,
      "v": 0.25,
      "lKey": "films:f-softmax.items.l2.l"
    },
    {
      "k": "bar",
      "id": "l3",
      "x": 60,
      "y": 160,
      "w": 170,
      "h": 14,
      "v": 0.07,
      "lKey": "films:f-softmax.items.l3.l"
    },
    {
      "k": "box",
      "id": "fn",
      "x": 284,
      "y": 100,
      "w": 120,
      "h": 64,
      "lKey": "films:f-softmax.items.fn.l",
      "sKey": "films:f-softmax.items.fn.s"
    },
    {
      "k": "wire",
      "id": "w1",
      "from": "l2",
      "to": "fn",
      "dash": true
    },
    {
      "k": "wire",
      "id": "w2",
      "from": "fn",
      "to": "p2",
      "dash": true
    },
    {
      "k": "bar",
      "id": "p1",
      "x": 450,
      "y": 64,
      "w": 170,
      "h": 14,
      "v": 0.92,
      "lKey": "films:f-softmax.items.p1.l"
    },
    {
      "k": "bar",
      "id": "p2",
      "x": 450,
      "y": 112,
      "w": 170,
      "h": 14,
      "v": 0.05,
      "lKey": "films:f-softmax.items.p2.l"
    },
    {
      "k": "bar",
      "id": "p3",
      "x": 450,
      "y": 160,
      "w": 170,
      "h": 14,
      "v": 0.03,
      "lKey": "films:f-softmax.items.p3.l"
    },
    {
      "k": "box",
      "id": "tp",
      "x": 284,
      "y": 210,
      "w": 120,
      "h": 56,
      "lKey": "films:f-softmax.items.tp.l",
      "sKey": "films:f-softmax.items.tp.s"
    },
    {
      "k": "note",
      "id": "n1",
      "x": 450,
      "y": 214,
      "lKey": "films:f-softmax.items.n1.l"
    }
  ],
  "steps": [
    {
      "on": [
        "h1",
        "l1",
        "l2",
        "l3"
      ],
      "hot": [
        "l1"
      ],
      "capKey": "films:f-softmax.steps.0.cap"
    },
    {
      "on": [
        "h1",
        "l1",
        "l2",
        "l3",
        "fn",
        "w1",
        "w2"
      ],
      "hot": [
        "fn",
        "w1",
        "w2"
      ],
      "capKey": "films:f-softmax.steps.1.cap"
    },
    {
      "on": [
        "h1",
        "l1",
        "l2",
        "l3",
        "fn",
        "w1",
        "w2",
        "h2",
        "p1",
        "p2",
        "p3"
      ],
      "hot": [
        "p1"
      ],
      "capKey": "films:f-softmax.steps.2.cap"
    },
    {
      "on": [
        "h1",
        "l1",
        "l2",
        "l3",
        "fn",
        "w1",
        "w2",
        "h2",
        "p1",
        "p2",
        "p3",
        "tp",
        "n1"
      ],
      "hot": [
        "tp",
        "n1"
      ],
      "capKey": "films:f-softmax.steps.3.cap"
    }
  ]
};
